export default class ApiPathMgr
{
    constructor() {
        this._urlPaths = [];
    }
    add(urlPath) {
        if (this._urlPaths.indexOf(urlPath)>=0) {
            throw new Error('urlPath added twice: ' + JSON.stringify(urlPath));
        }
        this._urlPaths.push(urlPath);
    }
}



// WEBPACK FOOTER //
// ./src/Utils/ApiPathMgr.js


// WEBPACK FOOTER //
// webpack:///src/Utils/ApiPathMgr.js